const baseUrl =
  "https://api-cdt.apmterminals.com/badactorapplication-transactionservicetest/api";
const baseAnalyticsUrl =
  "https://api-cdt.apmterminals.com/badactorapplication-analyticsservicetest/api/Analytics";
const baseActionTypesUrl =
  "https://api-cdt.apmterminals.com/badactorapplication-actiontypeservicetest/api/ActionType";
const weightinFactorsUrl =
  "https://api-cdt.apmterminals.com/badactorapplication-weightingfactorservicetest/weightingfactors";
const languageTransalationUrl =
  "https://api-cdt.apmterminals.com/badactorapplication-languagemappingservicetest/languagemapping";
const rolloutUrl =
  "https://api-cdt.apmterminals.com/badactorapplication-rollouttrackingservicetest/RolloutImplementation";
const identificationPrioritizationUrl =
  "https://api-cdt.apmterminals.com/badactorapplication-cubejswrapperservicetest/cubejswrapper";
const cubejsWrapperUrl =
  "https://api-cdt.apmterminals.com/badactorapplication-cubejswrapperservicetest/cubejswrapper";
const criticalAssetTypesUrl =
  "https://api-cdt.apmterminals.com/badactorapplication-criticalassettypeservicetest/criticalassettypes";
const counterMeasureUrl =
  "https://api-cdt.apmterminals.com/badactorapplication-countermeasureservicetest/api";

const roleEndPoint = "https://api-cdt.apmterminals.com/apmtdigitalamtechasset-userservicetest"
const reccomendationApiEndPoint = "https://api-cdt.apmterminals.com/badactorapplication-recommendationservicetest/api";


export const environment = {
  production: false,
  apiEndpoint: baseUrl,
  analyticsApiEndPoint: baseAnalyticsUrl,
  actionTypesApiEndPoint: baseActionTypesUrl,
  weightinFactorsUrlEndPoint: weightinFactorsUrl,
  languageTransalationEndPoint: languageTransalationUrl,
  rolloutUrlEndPoint: rolloutUrl,
  identificationPrioritizationEndPoint: identificationPrioritizationUrl,
  cubejsWrapperEndPoint: cubejsWrapperUrl,
  criticalAssetTypesEndPoint: criticalAssetTypesUrl,
  counterMeasureEndPoint: counterMeasureUrl,
  roleEndPoint: roleEndPoint,
  reccomendationApiEndPoint:reccomendationApiEndPoint,

  msalConfig: {
    auth: {
      clientId: "228dff03-6763-491a-b661-51098d556649",
      authority:
        "https://login.microsoftonline.com/05d75c05-fa1a-42e7-9cf1-eb416c396f2d",
    },
  },
  apiConfig: {
    scopes: ["api://228dff03-6763-491a-b661-51098d556649/access"],
    uri: "https://graph.microsoft.com/v1.0/me",
  },
  rumConfig: {
    appName: "BadActor-cdt",
    apiKey: "C+RrTcS1wahVglF4BQCrQ0H4/XdpBVKYFbuRcrBOTbKMULytQZwUzt3McPFyFg==",
  },
  gtmContainerId: "GTM-M44QCF38",
};
